"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ResourceTypes;
(function (ResourceTypes) {
    ResourceTypes["Fulfillers"] = "fulfillers";
    ResourceTypes["FulfillmentLocations"] = "fulfillment-locations";
    ResourceTypes["LogisticsLocation"] = "logistics-location";
    ResourceTypes["Calendar"] = "calendar";
    ResourceTypes["CarrierAccount"] = "carrier-account";
    ResourceTypes["LogisticsSequence"] = "logistics-sequence";
    ResourceTypes["LogisticsNetwork"] = "logistics-network";
})(ResourceTypes = exports.ResourceTypes || (exports.ResourceTypes = {}));
var FLPermissions;
(function (FLPermissions) {
    FLPermissions["ReadLogisticsConfigurationData"] = "read:logistics-configuration-data";
    FLPermissions["ManageLogisticsConfigurationData"] = "manage:logistics-configuration-data";
})(FLPermissions = exports.FLPermissions || (exports.FLPermissions = {}));
var LLPermissions;
(function (LLPermissions) {
    LLPermissions["Read"] = "read";
    LLPermissions["Delete"] = "delete";
    LLPermissions["Update"] = "update";
})(LLPermissions = exports.LLPermissions || (exports.LLPermissions = {}));
var CalendarPermissions;
(function (CalendarPermissions) {
    CalendarPermissions["Read"] = "read";
    CalendarPermissions["Delete"] = "delete";
    CalendarPermissions["Update"] = "update";
})(CalendarPermissions = exports.CalendarPermissions || (exports.CalendarPermissions = {}));
var CarrierAccountPermissions;
(function (CarrierAccountPermissions) {
    CarrierAccountPermissions["Read"] = "read";
    CarrierAccountPermissions["Delete"] = "delete";
    CarrierAccountPermissions["Update"] = "update";
})(CarrierAccountPermissions = exports.CarrierAccountPermissions || (exports.CarrierAccountPermissions = {}));
var LogisticsSequencePermissions;
(function (LogisticsSequencePermissions) {
    LogisticsSequencePermissions["Read"] = "read";
    LogisticsSequencePermissions["Update"] = "update";
    LogisticsSequencePermissions["Delete"] = "delete";
    LogisticsSequencePermissions["GetNext"] = "get-next";
})(LogisticsSequencePermissions = exports.LogisticsSequencePermissions || (exports.LogisticsSequencePermissions = {}));
var LogisticsNetworkPermissions;
(function (LogisticsNetworkPermissions) {
    LogisticsNetworkPermissions["Read"] = "read";
    LogisticsNetworkPermissions["Update"] = "update";
    LogisticsNetworkPermissions["ReadTransitCalendar"] = "read:transit-calendar";
})(LogisticsNetworkPermissions = exports.LogisticsNetworkPermissions || (exports.LogisticsNetworkPermissions = {}));
//# sourceMappingURL=coam-models.js.map